import { C as Cart } from './cart-eLzX7E8s.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import { p as parseHTML } from './parseHTML-Om2c1Ayj.js';
import './notyf-DIw0RvBj.js';
import './uniq-D7II7obF.js';

class CartDrawerSummary extends HTMLElement {
  #unsubscribers = [];
  #buttons = this.querySelectorAll('.button');

  static {
    Cart.sections.push('fetch-cart-drawer-summary');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
        PubSub.subscribe(event, ({ sections }) => this.#renderSection(sections))
      ),
      PubSub.subscribe('cart:fetch', ({ status }) => this.#handleLoading(status === 'pending'))
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  #renderSection(sections) {
    const html = parseHTML(sections['fetch-cart-drawer-summary']);
    const target = html.querySelector('cart-drawer-summary');
    this.replaceWith(target);
  }

  #handleLoading(loading) {
    this.#buttons.forEach((button) => {
      button.classList.toggle('loading', loading);
    });
  }
}

customElements.define('cart-drawer-summary', CartDrawerSummary);
